import React from "react";
import { Link } from "react-router-dom";
import { Newspaper, Video, Image, ArrowRight, Anchor, Ship, Settings, ShoppingBag } from "lucide-react";

const Dashboard: React.FC = () => {
  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-3xl font-bold text-gray-800">Hoş Geldiniz 👋</h1>
        <p className="text-gray-500 mt-2">Ayvalık Marin içerik yönetim paneli.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {/* News */}
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
          <div className="flex items-center justify-between mb-4">
            <div className="p-3 bg-blue-100 rounded-lg">
              <Newspaper className="w-6 h-6 text-blue-600" />
            </div>
          </div>
          <h3 className="text-lg font-bold text-gray-800">Haberler</h3>
          <Link
            to="/panel/news"
            className="inline-flex items-center mt-4 text-blue-600 hover:text-blue-700 font-medium"
          >
            Yönet <ArrowRight className="w-4 h-4 ml-2" />
          </Link>
        </div>

        {/* Videos */}
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
          <div className="flex items-center justify-between mb-4">
            <div className="p-3 bg-purple-100 rounded-lg">
              <Video className="w-6 h-6 text-purple-600" />
            </div>
          </div>
          <h3 className="text-lg font-bold text-gray-800">Videolar</h3>
          <Link
            to="/panel/videos"
            className="inline-flex items-center mt-4 text-purple-600 hover:text-purple-700 font-medium"
          >
            Yönet <ArrowRight className="w-4 h-4 ml-2" />
          </Link>
        </div>

        {/* Gallery */}
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
          <div className="flex items-center justify-between mb-4">
            <div className="p-3 bg-green-100 rounded-lg">
              <Image className="w-6 h-6 text-green-600" />
            </div>
          </div>
          <h3 className="text-lg font-bold text-gray-800">Galeri</h3>
          <Link
            to="/panel/gallery"
            className="inline-flex items-center mt-4 text-green-600 hover:text-green-700 font-medium"
          >
             Yönet <ArrowRight className="w-4 h-4 ml-2" />
          </Link>
        </div>

        {/* Boats */}
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
          <div className="flex items-center justify-between mb-4">
            <div className="p-3 bg-cyan-100 rounded-lg">
              <Anchor className="w-6 h-6 text-cyan-600" />
            </div>
          </div>
          <h3 className="text-lg font-bold text-gray-800">Tekneler</h3>
          <Link
            to="/panel/boats"
            className="inline-flex items-center mt-4 text-cyan-600 hover:text-cyan-700 font-medium"
          >
             Yönet <ArrowRight className="w-4 h-4 ml-2" />
          </Link>
        </div>

        {/* Used Boats */}
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
          <div className="flex items-center justify-between mb-4">
            <div className="p-3 bg-orange-100 rounded-lg">
              <Ship className="w-6 h-6 text-orange-600" />
            </div>
          </div>
          <h3 className="text-lg font-bold text-gray-800">2. El Tekneler</h3>
          <Link
            to="/panel/used-boats"
            className="inline-flex items-center mt-4 text-orange-600 hover:text-orange-700 font-medium"
          >
             Yönet <ArrowRight className="w-4 h-4 ml-2" />
          </Link>
        </div>

        {/* Engines */}
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
          <div className="flex items-center justify-between mb-4">
            <div className="p-3 bg-red-100 rounded-lg">
              <Settings className="w-6 h-6 text-red-600" />
            </div>
          </div>
          <h3 className="text-lg font-bold text-gray-800">Motorlar</h3>
          <Link
            to="/panel/engines"
            className="inline-flex items-center mt-4 text-red-600 hover:text-red-700 font-medium"
          >
             Yönet <ArrowRight className="w-4 h-4 ml-2" />
          </Link>
        </div>

         {/* Products */}
         <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
          <div className="flex items-center justify-between mb-4">
            <div className="p-3 bg-pink-100 rounded-lg">
              <ShoppingBag className="w-6 h-6 text-pink-600" />
            </div>
          </div>
          <h3 className="text-lg font-bold text-gray-800">Ürünler</h3>
          <Link
            to="/panel/products"
            className="inline-flex items-center mt-4 text-pink-600 hover:text-pink-700 font-medium"
          >
             Yönet <ArrowRight className="w-4 h-4 ml-2" />
          </Link>
        </div>

      </div>
    </div>
  );
};

export default Dashboard;
